import { useEffect } from "react"
import ContentPageContainer from "components/molecules/common/ContentPageContainer"
import useTranslations from "../hooks/useTranslations"

const NotFoundPage = () => {
  const { page404Title, page404Description } = useTranslations()

  // Plausible's documented 404 tracking: a custom event named "404" carrying
  // the path that was missed. Needs a matching "404" custom-event goal in the
  // Plausible dashboard, otherwise the events arrive but are not reported.
  //
  // window.plausible is always defined by the queue stub in gatsby-browser.js,
  // so this cannot drop the event when the tracker is still loading.
  //
  // Only fires for visitors that run JavaScript, so it records broken links
  // people actually followed. It will not show the bulk of the 404s in the
  // CloudFront logs, which are vulnerability scanners probing for /.env,
  // /wp-login.php and similar and never execute any script.
  useEffect(() => {
    if (typeof window === "undefined") return
    window.plausible("404", { props: { path: window.location.pathname } })
  }, [])

  return (
    <ContentPageContainer title={page404Title}>
      <p className="m-0 text-zinc-800">{page404Description}</p>
    </ContentPageContainer>
  )
}

export default NotFoundPage
